const course = {
    state: {
      coursedetail:{}
    },
  
    mutations: {
      SET_COURSE: (state, coursedetail) => {
        state.coursedetail = coursedetail
      },
  
    },
  
    actions: {
      // 设置课时内容
      setcourse({ commit },coursedetail) {
          commit('SET_COURSE',coursedetail)
      },
    }
  }

  
  export default course
  